import _objectSpread from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7ebbf5ca"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "api-content"
};
var _hoisted_2 = {
  class: "tip"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("By submitting this form, you agree to our ");

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" and ");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Get Permission");

var _hoisted_6 = {
  key: 1,
  class: "api-content"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "align-left"
  }, "Now you can currently try all our API services for 5 requests each.", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "mb12 align-left"
  }, "Please save the following information properly, before jumping out of this page.", -1);
});

var _hoisted_9 = {
  class: "mb12 key"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode("appKey: ");

var _hoisted_11 = {
  class: "high-text"
};
var _hoisted_12 = {
  class: "mb12 key"
};

var _hoisted_13 = /*#__PURE__*/_createTextVNode("secretKey: ");

var _hoisted_14 = {
  class: "high-text"
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "mb10"
  }, "For a detailed API configuration guide, please visit:", -1);
});

var _hoisted_16 = /*#__PURE__*/_createTextVNode("API Documentation");

var _hoisted_17 = /*#__PURE__*/_createTextVNode("Quick Trial Guide");

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "tip"
  }, "Note: You currently only have temporary API request permission, and Riscern has the right to revoke this temporary permission at any time.", -1);
});

import DefaultDialog from '@/components/DefaultDialog';
import termsInfoDialog from './termsInfoDialog';
import privaryInfoDialog from './privaryInfoDialog';
import { ref, reactive } from 'vue';
import { apiTestUserBind } from '@/api/common';
import { emailSuffix } from '@/utils/emailUtils';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var subBtnLoading = ref(false);
    var ruleFormRef = ref();
    var termsDialogVisible = ref(false);
    var privaryDialogVisible = ref(false);
    var apiKeyInfo = ref({
      appKey: '',
      secretKey: ''
    });
    var form = reactive({
      name: '',
      email: '',
      companyName: ''
    });
    var rulesForm = reactive({
      name: [{
        required: true,
        message: 'Please input name',
        trigger: ['blur', 'change']
      }],
      email: [{
        required: true,
        type: 'email',
        message: 'Please enter your business email address',
        trigger: ['blur', 'change']
      }, {
        type: 'string',
        validator: function validator(rule, value) {
          var _val = value || '';

          var suffix = _val.split('@')[1];

          var _suffixInfo = suffix.split('.')[0]; // 不在黑名单内 且 不是纯数字

          return !emailSuffix.includes(suffix) && isNaN(_suffixInfo);
        },
        message: 'Please enter your business email address',
        trigger: ['blur', 'change']
      }],
      companyName: [{
        required: true,
        message: 'Please input companyName',
        trigger: ['blur', 'change']
      }]
    }); // 提交

    function submitForm(_x) {
      return _submitForm.apply(this, arguments);
    }

    function _submitForm() {
      _submitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formEl) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (formEl) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return formEl.validate(function (valid, fields) {
                  if (valid) {
                    subBtnLoading.value = true;
                    apiTestUserBind(_objectSpread({}, form)).then(function (_ref) {
                      var data = _ref.data;
                      apiKeyInfo.value = data;
                    }).finally(function () {
                      subBtnLoading.value = false;
                    });
                  } else {
                    console.log('error submit!', fields);
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _submitForm.apply(this, arguments);
    }

    function onHrefWindowBlank(url) {
      window.open(url, 'blank');
    }

    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createBlock(_unref(DefaultDialog), _mergeProps(_ctx.$attrs, {
        width: "31%",
        "custom-class": "default-dialog no-footer-dialog",
        title: apiKeyInfo.value.appKey ? 'API Request Permissions' : 'Get API Request Permissions Now'
      }), {
        default: _withCtx(function () {
          return [!apiKeyInfo.value.appKey ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: _unref(form),
            rules: _unref(rulesForm),
            "label-width": "0"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "name"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    maxlength: "50",
                    modelValue: _unref(form).name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(form).name = $event;
                    }),
                    placeholder: "Name",
                    class: "item-input"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                prop: "email"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    maxlength: "50",
                    modelValue: _unref(form).email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(form).email = $event;
                    }),
                    placeholder: "Work Email",
                    class: "item-input"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                prop: "companyName"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    maxlength: "50",
                    modelValue: _unref(form).companyName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _unref(form).companyName = $event;
                    }),
                    placeholder: "Company Name",
                    class: "item-input"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", {
            class: "high-text",
            onClick: _cache[3] || (_cache[3] = function () {
              return termsDialogVisible.value = true;
            })
          }, "Terms of Service"), _hoisted_4, _createElementVNode("span", {
            class: "high-text",
            onClick: _cache[4] || (_cache[4] = function () {
              return privaryDialogVisible.value = true;
            })
          }, "Privacy Policy.")]), _createVNode(_component_el_button, {
            type: "primary",
            class: "project-btn",
            loading: subBtnLoading.value,
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return submitForm(ruleFormRef.value);
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          }, 8, ["loading"])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", _hoisted_11, _toDisplayString(apiKeyInfo.value.appKey), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(apiKeyInfo.value.secretKey), 1)]), _hoisted_15, _createVNode(_component_el_button, {
            type: "primary",
            class: "project-btn mb10",
            onClick: _cache[6] || (_cache[6] = function ($event) {
              return onHrefWindowBlank('https://documenter.getpostman.com/view/13198849/UyxdKU7T');
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_16];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "default-btn mb10",
            onClick: _cache[7] || (_cache[7] = function ($event) {
              return onHrefWindowBlank('https://docs.google.com/document/d/1TjcO4m2XcCJRG15vsCJyV2np5ry_AcRW6b_K6iRJd4Y/edit?usp=sharing');
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_17];
            }),
            _: 1
          }), _hoisted_18])), _createVNode(_unref(termsInfoDialog), {
            modelValue: termsDialogVisible.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return termsDialogVisible.value = $event;
            })
          }, null, 8, ["modelValue"]), _createVNode(_unref(privaryInfoDialog), {
            modelValue: privaryDialogVisible.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
              return privaryDialogVisible.value = $event;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 16, ["title"]);
    };
  }
});